import allPromisesWithRetries from '@/helpers/allPromisesWithRetries'

// Here is where it all comes together
export const getSavedInstrumentsCredentials = async () => {
  const [
    { getRegisteredUserCredentials },
    { getGuestUserCredentials },
  ] = await allPromisesWithRetries(() => [
    import('./getRegisteredUserCredentials'),
    import('./getGuestUserCredentials'),
  ])
  try {
    return await getRegisteredUserCredentials()
  } catch (e) {
    return await getGuestUserCredentials()
  }
}

export default getSavedInstrumentsCredentials
